<template>
    <div class="animated fadeIn">
        <div>
            <!-- <div class="float-right">
                <b-button
                    @click="
                        $router.push(
                            `/partner/view/${$route.params.id}/view-invoice/unbilled`,
                        )
                    "
                    size="sm"
                    class="mb-2 mt-n2"
                    variant="primary"
                    style="position: relative; top: 19px; margin-left: 10px"
                >
                    Unbillied Invoice
                </b-button>
            </div> -->
            <component-header
                :title="`${
                    partnerAllData ? partnerAllData.authentication.userName : ''
                } - Invoice History`"
                :hasUnbilliedInvoice="true"
                @unbillied-invoice-press="
                    $router.push(
                        `/partner/view/${$route.params.id}/view-invoice/unbilled`,
                    )
                "
                :hasCreate="false"
                :hasback="true"
                @back-press="$router.push('/partner')"
                @reload-data="getPartnerInvoiceListData"
                :isLoading="isloading"
                :hasSearch="false"
            />
            <b-card class="card-wrap invoice-table-card" border-variant="info">
                <div>
                    <b-table
                        :dark="false"
                        :hover="true"
                        :striped="false"
                        :bordered="true"
                        :small="false"
                        :fixed="false"
                        responsive="sm"
                        :items="invoiceList"
                        :fields="invoiceColumns"
                        :current-page="currentPage"
                        :per-page="perPage"
                        thead-class="header"
                        show-empty
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(action)" slot-scope="data">
                            <b-button
                                @click="viewDetails(data)"
                                size="sm"
                                class="mr-2"
                                variant="primary"
                            >
                                <i
                                    style="color: white !important"
                                    class="far fa-eye edit"
                                ></i>
                            </b-button>
                        </template>
                        <template slot="cell(empty)">
                            <div v-if="isloading" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div v-else class="text-center">
                                No data available.
                            </div>
                        </template>

                        <template slot="cell(status)" slot-scope="data">
                            <p>
                                <img src="img/Ellipse63.png" alt="" />
                                {{ data.item.status }}
                            </p>
                        </template>
                    </b-table>
                </div>
                <div class="float-right">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="invoiceList.length"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-card>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import loader from "@/components/loader/nipigeloader.vue";
import moment from "moment";
export default {
    name: "InvoiceHistory",
    components: {
        ebButton,
        ComponentHeader,
        loader,
    },
    data() {
        return {
            isloading: false,
            currentPage: 1,
            perPage: 10,
            sortBy: "createdAt",
            sortDesc: true,
            invoiceColumns: [
                {
                    key: "id",
                },
                {
                    key: "billStartDate",
                },
                {
                    key: "billEndDate",
                },
                {
                    key: "description",
                },
                {
                    key: "billDueDate",
                },
                {
                    key: "invoiceDate",
                },
                {
                    key: "tax",
                },
                {
                    key: "charge",
                },
                {
                    key: "total",
                },
                {
                    key: "action",
                },
            ],
        };
    },
    computed: {
        ...mapGetters({
            partnerAllData: "partner/GetPartnerData",
            getPartnerInvoice: "invoice/GetPartnerInvoice",
        }),

        invoiceList() {
            let data = this.getPartnerInvoice;
            let invoiceList = [];
            if (Array.isArray(data) && data.length > 0) {
                data.map((obj) => {
                    let num = obj.invoiceNumber.toString();
                    while (num.length < 10) num = "0" + num;
                    let arrObj = {
                        _id: obj._id,
                        id: "#" + num,
                        status: obj.status,
                        billStartDate: this.getProperDate(obj.startDate),
                        billEndDate: this.getProperDate(obj.endDate),
                        description: `Invoice for Amount INR ${obj.totalAmount.toFixed(
                            2,
                        )} generated for period ${this.getProperDate(
                            obj.startDate,
                        )} to  ₹ ${this.getProperDate(obj.endDate)}`,
                        billDueDate: this.getProperDate(obj.dueDate),
                        invoiceDate: this.getProperDate(obj.createdAt),
                        tax: obj.totalTaxes.toFixed(2),
                        charge: obj.chargeAmount.toFixed(2),
                        total: obj.totalAmount.toFixed(2),
                        ...obj,
                    };
                    invoiceList.push(arrObj);
                });
                return invoiceList;
            } else {
                return [];
            }
        },
    },
    methods: {
        viewDetails(data) {
            this.$store.dispatch("invoice/singlePartnerInvoice", data.item);
            this.$router.push({ path: "view-invoice/details" });
        },
        async getPartnerInvoiceListData() {
            this.isloading = true;
            await this.$store
                .dispatch("invoice/fetchPartnerInvoice", {
                    id: this.partnerAllData._id,
                    data: {},
                })
                .then(() => (this.isloading = false))
                .catch(() => (this.isloading = false));
        },
        getProperDate(data) {
            if (data != null) {
                let date = new Date(data);

                return moment(String(date)).format("DD/MM/YYYY");
            } else {
                return "Unavailable";
            }
        },
    },

    async mounted() {
        if (this.partnerAllData == null) {
            await this.$store.dispatch(
                "partner/fetchPartnerById",
                this.$route.params.id,
            );
        }
        this.isloading = true;
        await this.$store
            .dispatch("invoice/fetchPartnerInvoice", {
                id: this.partnerAllData._id,
                data: {},
            })
            .then(() => (this.isloading = false))
            .catch(() => (this.isloading = false));
    },
};
</script>
